/*
    global
        Dropzone,
        locale,
        moment,
        params,
        user,
        ajaxload,
        jsonSave,
        initComponents,
        notify
*/

/** ******************************
xDropZone
written by Genys, Renatas & Danielius
2016.09.14 @ Lexita

v.0.4 07.18 18.20
********************************* */

var xdropzone = function() {};

xdropzone.prototype = {
  get globals() {
    var me = this;
    //debugger;
	return params.mode === 'tvs'
      ? {
          loadJson: {
            length : 500,
            orderby: 'SortOrder',
            page   : 1,
            pk     : 'DocumentId',
            select : `
                    Date,
                    DocumentId,
                    Ext,
                    IsDeleted,
                    Name,
                    Path,
                    Size,
                    REPLACE(Path, "/files/", "/cache/${this.getThumbnailSize()}/photos/") AS Thumbnail
                `,
            start: 0,
            table: table +' d'
          },
          removeJson: {
            action   : 'edit',
            IsDeleted: 1,
            pk_key   : 'DocumentId',
            table    : me.params.table
          },
          sortableJson: {
            action: 'edit',
            pk_key: 'DocumentId',
            table : me.params.table
          }
        }
      : {
          loadJson: {
            length : 500,
            orderby: 'SortOrder',
            page   : 1,
            pk     : 'DocumentId',
            select : `
                    Date,
                    DocumentId,
                    DocumentId as pk,
                    Ext,
                    Name,
                    Path,
                    Size
                `,
            // select : `
            //         Date,
            //         DocumentId as pk,
            //         Ext as ext,
            //         Name as name,
            //         Path as path,
            //         Size as size
            //     `,
            start: 0,
            table: me.params.table
          },
          removeJson: {
            action   : 'edit',
            IsDeleted: 1,
            pk_key   : 'DocumentId',
            table    : me.params.table
          },
          sortableJson: {
            action: 'edit',
            pk_key: 'DocumentId',
            table : me.params.table
          }
        };
  },
  init(el, params) {
    if (el.hasClass('xdropzone--rendered')) {
      return this;
    }

    el.addClass('xdropzone--rendered zone');

    var me = this,
      id = el.attr('id') || `xdropzone-${xhelper.string.guid()}`;

    me.id = id;
    me.el = el;
    me.uploader = el.closest('.uploader');
    me.buttonId = xhelper.string.guid();

    me.getLang();

    var config = me.read(el, params);
	//debugger;
    params.id = `#${id}`;
    params.table = params.table || 'reus.Documents';
    me.params = params;
    me.config = config;
    me.onlyUpload = params.onlyUpload || false;

    me.magnificConfig.disableOn = function() {
      return !me.el.hasClass('uploader--edit-mode');
    };

    // jei yra typeId nurodytas, tai reikia paduoti jį į upload.php
    var match = /((\\&|\\?)type=(.*)[^&]*)/g.exec(location.search);
    if (match && match[3]) {
      params.data.TypeId = match[3];
    }

    me.render(el, 'zone', id);
    $(() => {
      var zone = el.find('form').filter('#' + id).dropzone(config);
      if (me.params.buttonId) {
        zone.find('.dz-message').remove(); // if custom button is defined
      }
      if (params.mode == 'app') {
        $(window)
          .off('message.dz')
          .on('message.dz', e => {
            let r = e.originalEvent;
            let zone = $('#' + r.data.zone)[0].dropzone;

            if (r.data && r.data.type.indexOf('dropzone') === -1) {
              return;
            }

            switch (r.data.type) {
              case 'dropzone.files':
                me.app_addFiles(r, zone);
                break;
              case 'dropzone.files.progress':
                me.app_updateProgress(r, zone);
                break;
              case 'dropzone.files.complete':
                me.app_completeFile(r, zone);
                break;
            }
          });

        var target_btn = $(params.buttonId);
		//debugger;
        if (target_btn.length) {
          params.zone = me.id;
          params.type = 'dropzone';
          params.action = 'capture_images';
          params.quality = 70;
          params.url = (params.url || 'http://' + window.location.hostname + '/upload/documents'),
            target_btn.off('click').on('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              /**
               * Filter callbacks
               */
              const postMsg = Object.keys(params).reduce((acc, pKey) => {
                const p = params[pKey];
                if (typeof p !== 'function') {
                  acc[pKey] = p;
                }
                return acc;
              }, {});

              window.parent.postMessage(postMsg, '*');
            });
        }
        
      }

      me.loadFiles().then(() => {
          me.switchMode();
          if (params.checkMode) me.editMode();
          if (params.reorderable) me.sortable();
      }).catch(err => {});
    });

    return me;
  },
  read(el, params) {
  var me = this,

      config = {
        acceptedFiles               : params.acceptedFiles,
        mode                        : params.mode,
        gallery                     : params.gallery,
        addRemoveLinks              : false,
        autoDiscover                : false,
        autoProcessQueue            : false,
        clickable                   : params.buttonId || `#dropzone-button-${me.buttonId}`,
        maxFilesize                 : params.maxFileSize || 4096,
        resizeWidth                 : params.resizeWidth || null,
        resizeHeight                : params.resizeHeight || null,
        maxThumbnailFilesize        : 30,
        parallelUploads             : 1,
        paramName                   : 'file',
        thumbnailHeight             : 132,
        thumbnailWidth              : 132,
        timeout                     : 20 * 60 * 1000, // (20 minutes)
        // vertimai
        dictCancelUpload            : '',
        dictCancelUploadConfirmation: me.lang.dictCancelUploadConfirmation,
        dictDefaultMessage          :
          params.acceptedFiles === 'image/*'
            ? me.lang.uploadImage
            : me.lang.dictUploadFilesHere,
        dictFallbackMessage       : me.lang.dictFallbackMessage,
        dictFallbackText          : me.lang.dictFallbackText,
        dictFileTooBig            : me.lang.dictFileTooBig,
        dictInvalidFileType       : me.lang.dictInvalidFileType,
        dictMaxFilesExceeded      : me.lang.dictMaxFilesExceeded,
        dictRemoveFile            : '',
        dictRemoveFileConfirmation: me.lang.dictRemoveFileConfirmation,
        dictResponseError         : me.lang.dictResponseError,
        previewTemplate           : `
          <a class="dz-preview dropzone-item" draggable="false">
         
              <span class="dropzone-file-format dropzone-format-image"></span>
              <div class="svg-loader">
                  <svg viewBox="0 0 32 32" width="32" height="32">
                      <circle cx="16" cy="16" r="14" fill= "none" style="stroke-width: 2px; stroke: #ccc"></circle>
                  </svg>
              </div>
              <div class="dropzone-item-info">
                  <div data-dz-name></div>
                  <span class="dropzone-item-progress" data-dz-uploadprogress></span>
              </div>
              <div class="dropzone-item-actions">
                  ${params.mode == 'app' || params.editMode === false ? '' : '<span title="Redaguoti" data-dz-edit class="btn btn-icon btn-primary"></span>'}

                  ${params.mode == 'app' ? '' : '<span data-dz-zoom class="btn btn-icon btn-primary"></span>'}

                  ${me.onlyUpload ? '' : `<span title="${me.lang.dictDelete}" data-dz-remove class="btn btn-icon btn-danger btn-icon"></span>`}
              </div>
          </a>
        `,
        data    : params.data || {},
        maxFiles: params.limit || null,
        dataType: 'json',
        url     : params.url || web.zone + `/upload/documents`,

          //${params.documents === false ? '?input = false' : ''}
        init() {
          var zone = this;

          me.zone = this;

          me.setEvents(zone, params);

          if (typeof params.init === 'function') {
            params.init(zone); // dropzona, formos id
          }

          if (params.load && params.load.length > 0) {
            me.loadFiles(zone, params.load);
            me.repairThumbnails(params.load);
          }
        },
        drop() {},
        uploadprogress(file, progress, bytesSent) {
          // Display the progress
          var string = `${me.humanFileSize(bytesSent)}/${me.humanFileSize(
            file.size
          )}`;

          $(file.previewElement)
            .find('.dropzone-item-progress')
            .attr('data-string', string);
        },
        success(file) {
          var item = file.previewElement,
            path = file.path,
            tooltip = `
                            <b>${file.name}</b><br>
                            <div class="text-muted-w">
                                <div>${
                                  file.ModuleName ? file.ModuleName : ''
                                }</div>
                                <div>${moment(file.lastModified).format(
                                  'YYYY.MM.DD HH:MM'
                                )}</div>
                                <div></div>
                                <div>${me.humanFileSize(file.size)}</div>
                            </div>
                        `;
        // 306 eil : ${file.EmployeeName || user.name}
          if (file.xhr !== undefined) {
            console.log(file.xhr);
            path = JSON.parse(file.xhr.response).path;
          }

          item.setAttribute('href', path);

          var iteminfo = item.querySelector('.dropzone-item-info');

          iteminfo.style.display = '';
          item.setAttribute('data-tooltip', tooltip);
        },
        complete(file) {
          var item = $(file.previewElement),
            path = file.path,
            pk; 

          if (file.status === 'error') return;

          if (file.xhr !== undefined) {
            var obj = JSON.parse(file.xhr.response);
            pk = obj.pk;
            path = obj.path || file.path;
          }

          item.attr('data-pk', pk || file.pk);

          var previewUrl = me.getPreviewUrl(file);
          var isPDF = !/^(.*\.(?!(pdf)$))?[^.]*$/gi.test(file.name);

          if (previewUrl) {
            var $format = item
              .attr('target', '_blank')
              .addClass('dz-image')
              .find('.dropzone-file-format');

            if (xhelper.file.isDocument(path)) {
              item.addClass('dz-document');
              $format.append($(`<span data-format="${path}" />`)[0]);
            } else {
              item.attr('data-mfp-src', path);
            }

            const bigPreviewUrlviewUrl = me.getPreviewUrl(file, 600, false);

            $format.attr(
              'data-format',
              file.name
            )[0].style.backgroundImage = `url("${previewUrl}")`;

            // Bigger file previews on hover
            if ($.fn.tooltipster) {
              item.tooltipster({
                content      : `<img src="${bigPreviewUrlviewUrl}">`,
                contentAsHTML: true,
                debug        : true,
                interactive  : true,
                trigger      : 'custom',
                theme        : 'widget',
                multiple     : true,
                triggerOpen  : {
                  click     : false,
                  mouseenter: false,
                  touchstart: false,
                  tap       : false
                },
                functionReady(instance, helper) {
                  const img = helper.tooltip.querySelector('img');
                  img.onload = function() {
                    instance.reposition();
                  };
                  if (img.complete) {
                    instance.reposition();
                  }
                }
              });

              const openPreview = (e) => {
                xlog(e);
                const instances = $.tooltipster.instances(item);
                instances[0].open();
              };

              const closePreview = () => {
                const instances = $.tooltipster.instances(item);
                instances[0].close();
              };
              
              item.find('[data-dz-zoom]').on('click mouseenter', openPreview).mouseleave(closePreview);
            }
          } else {
            item.addClass('dz-file');
          }

          item
            .attr('target', '_blank')
            .addClass('dz-complete')
            .find('.dropzone-file-format')
            .attr('data-format', file.name);

          if (!isPDF) {
            item.attr('download', file.name);
          }

          setTimeout(() => {
            item.find('[data-dz-uploadprogress]').remove();
          }, 200);

          me.checkMax();

          item.magnificPopup(me.magnificConfig);
        }
      };

    if (params.config) {
      return $.extend({}, config, params.config);
    }

    if (config.mode == 'app' && params.buttonId) {
      config.clickable = false;
    }

    return config;
  },
  setEvents(zone, params) {
    var me = this,
      files = [];

    zone.id = `#${me.id}`;
    me.files = files;
    me.errors = false;
    

    if (isMobile.any() == false) {
      me.initPaste($(zone.element));
    }

    zone
      .on('addedfile', () => {
        me.checkMax();

      })
      .on('addedfiles', list => {
        if (typeof params.start === 'function') {
          params.start(list, list.length);
        }

        setTimeout(() => {
          // nesuveikia iskarto del qued fiels statuso
          zone.processQueue();
        }, 1);
      })
      .on('removedfile', file => {
        if (file.xhr) {
          file.pk = JSON.parse(file.xhr.response).pk;
        }
        const fpk = file.DocumentId || file.pk;

        if (fpk !== undefined) {
          me.files = me.zone.files = me.zone.files.filter(
            el => {
              let docPk = el.DocumentId || el.pk;
              return docPk !== fpk;
            }
          );
          $(zone.element)
            .closest('.upload-zone')
            .trigger('xdropzone.remove', me);
          me.checkMax();

          // ištrynė failą per simple view
          var removeData = me.globals.removeJson;
          removeData.pk_val = fpk;


          xcrud.json.save(null, removeData, function() {

            if(typeof params.data.onRemove === 'function') {
              params.data.onRemove(file);
            }

          }, {disablenotify: true});
          
        }
      })
      .on('sending', (file, xhr, formData) => {
        $.each(params.data, (key, value) => {
          
          if(typeof value !== 'function' && key !== 'whereJSON'){
            if (typeof value === 'object' && value !== null) {
              $.each(value, function(key, value) {
                formData.append(key, value);
              });
            } else {
              formData.append(key, value);
            }
          }
        });
      })
      .on('success', (file, resp) => {
        var response;
        if (typeof resp === 'string') {
          try {
            response = JSON.parse(resp);
          } catch (err) {
            me.error(params, file, 'error', null);
            return;
          }
        } else {
          response = resp;
        }

        if (response !== undefined) {
          if (!response.success) {
            me.error(params, file, response.msg, null);
            return;
          }
          // cia yra nesamone, kad cia hardcodintas objektas. Jeigu upload.php grazina daugiau parametru, tai reikia dar papildomai ir cia redaguoti.... xbug.
          //file.user = user.name;

          var filee = {
            name: file.name,
            size: file.size,
            path: response.path,
            ext : response.path.substring(
              response.path.lastIndexOf('.') + 1,
              response.path.length
            ),
            pk      : response.pk,
            modified: file.lastModified,
            mimetype: response.MIMEType
          };

          me.files.push(filee);

          if (typeof params.onsuccess == 'function') {
            params.onsuccess(filee);
          }
        }

        if (!file.mock) {
          me.reloadXGrid();
        }

        $inserted = response ? response.inserted : false;
      })
      .on('error', (file, error, xhr) => {
        debugger;
        me.error(params, file, error, xhr);
      })
      .on('complete', function() {
        if (me.errors) {
          return;
        }
        this.processQueue();
      })
      .on('completemultiple', () => {
        // if (me.errors) return;
      })
      .on('queuecomplete', () => {
        // all files complete
        //initComponents();
        me.showActions();
        
        if (me.errors) {
          return;
        }

        if (typeof params.complete === 'function') {
          params.complete(files, files.length);
        }

        // var allowonupload = false;

        // $(files).each(function(key, val){
        //   allowonupload = val.accepted === undefined || allowonupload;
        // });
        
        if(me.rendered === true) {
          if (typeof me.params.onUpload === 'function' && $inserted) { 
            me.params.onUpload(files);
            $inserted = false;
          }
        }

        me.el.trigger('xdropzone.complete', [files]);

        
        // $('[data-dz-edit]').off('click').on('click', function(e){
        //   let pk = $(this).closest('a').attr('data-pk');

        //   xdialog.modal.show({ 
        //     title: "Redaguoti", 
        //     edit_file: true, 
        //     extra_update: params.data.extra_update
        //   }, `/upload/edit_file/${pk}`);

        //   return false;
        // });
        $('[data-dz-edit]').off('click').on('click', function(e){
          let pk = $(this).closest('a').attr('data-pk');
          
          xdialog.modal.show({ 
            title: "Redaguoti", 
            edit_file: true, 
            extraUpdate: params.cropperExtraUpdate,
            options: {
              editName: params.editName,
              editDescription: params.editDescription,
              allowCrop: params.allowCrop
            }
          }, `/upload/edit_file/${pk}`);

          return false;
        });

      });


      me.rendered = true;
  },
  initPaste: target => {
    var me = this;
    target.off('mouseenter').on('mouseenter', e => {
      var el = $(e.target),
        fakeInput = $(
          '<textarea class="simple" contenteditable style="position: absolute; opacity: 0; top:0;left: 0; pointer-events: none; width: 0; height: 0;"></textarea>'
        );

      if (el.find('textarea.simple').length) {
        fakeInput = el.find('textarea.simple');
      } else {
        fakeInput.appendTo(el);
      }

      fakeInput.focus();

      var paste = function(event) {
        var items = (event.clipboardData || event.originalEvent.clipboardData)
          .items;

        $.each(items, (index, item) => {
          if (item.kind === 'file') {
            zone.addFile(item.getAsFile());
            zone.processQueue();
            me.showActions();
          }
        });
      };

      var mouseLeave = function() {
        fakeInput.off('paste.dropzone');
        fakeInput.remove();
      };
      fakeInput.on('paste.dropzone', paste);
      el.off('mouseleave').one('mouseleave', mouseLeave);
    });
  },
  reloadXGrid() {
    let me = this,
      cont = me.uploader;

    try {
      if (cont.length && typeof $.fn.xGrid === 'function') {
        var xtable = cont.find('.file-table')[0].gridas;
        if (!xtable) return;
        xtable.ajaxload();
      }
    } catch (e) {}
  },
  error(params, file, error, xhr) {
    this.errors = true;
    this.zone.removeFile(file);
    if (typeof params.error === 'function') {
      params.error(file, error, xhr);
      return;
    }

    if (!xhr) {
      xdialog.notify.show('Klaida', error, 'warning');
    } else if (xhr.status === 404) {
      xdialog.notify.show('Klaida', 'URL neegzistuoja', 'warning');
    }
  },
  humanFileSize(bytes, si) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
      return `${bytes} B`;
    }
    var units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
  },
  render(el, type, id) {
    var me = this,
      tpl;

    var uploadText = me.lang.dictUploadFilesHere;

    if (me.params.acceptedFiles === 'image/*') {
      uploadText = me.lang.uploadImage;
    }

    if (type == 'zone') {
      tpl = `${'<div class="dropzone-c">' +
        '<form class="dropzone" id="'}${id}">`;

      if (!this.params.buttonId) {
        tpl +=
          `${'<div ' +
            'class="uploader-add dz-message" ' +
            'id="dropzone-button-'}${me.buttonId}"` + `><div class="dz-message-content">
              ${uploadText}
            </div></div>`;
      }

      tpl += '</form>' + '</div>';
    }

    el.append(tpl);
    el.show();
    el.magnificPopup(me.magnificConfig);
    return el.find('form');
  },
  repairThumbnails(list) {
    for (var i = 0; i < list.length; i++) {
      var file = list[i];

      file.employeeName = user.name;
    }
  },
  appendFiles(list, callback) {
    var me = this,
      zone = this.zone;

    me.el.find('.dropzone-item').remove();

    list.forEach(file => {
      var mockFile = {
        mock              : true,
        pk                : file.DocumentId,
        EmployeeName      : file.EmployeeName,
        ModuleName        : file.ModuleName,
        name              : file.Name,
        size              : file.Size,
        lastModified      : file.Date,
        lastModifiedDate  : new Date(file.Date),
        path              : file.Path,
        thumbnail         : file.Thumbnail,
        webkitRelativePath: file.Path
      };

      zone.emit('addedfile', mockFile);
      zone.emit('success', mockFile);
      zone.emit('complete', mockFile);

      file.accepted = true;

      me.files.push(file);

      me.zone.files.push(file);

      me.checkMax();
    });

    if (typeof callback === 'function') {
      callback();
    }
  },
  loadFiles() {
    return new Promise((resolve, reject) => {
      var me = this,
        params = me.params,
        filterExtend = '';

      /* DALIUS PERKELE */
      if (me.onlyUpload === true) {
        resolve();
        return;
      }
      /* END DALIUS PERKELE */
      if (!params.data) reject('{data: ...} is not defined', params);

      $.each(params.data, (key, value) => {
        if(typeof value !== 'function' ){
          if (value && key !== 'whereJSON' && typeof value !== 'object') {
            filterExtend += `${key}-eq:${value};`;
          }
        }
      });

      me.ajaxload(
        Object.assign({}, me.globals.loadJson, {
          fixedFilter: `IsDeleted-eq:0;${params.data.whereJSON || filterExtend}`
        })
      ).then(data => me.appendFiles(data, resolve));
    });
  },
  ajaxload(ajaxConfig) {
    return new Promise((resolve, reject) => {
      if (!ajaxConfig) reject();

      $.ajax({
        url     : '/json/load',
        type    : 'POST',
        dataType: 'json',
        data    : ajaxConfig,
        success(response) {
          if (response.success === false) {
            reject('query error', response);
          }
          resolve(response.data);
        }
      });
    });
  },
  showActions() {
    var me = this,
      files = me.uploader.find('.dropzone-item'),
      actions = me.uploader.find('.uploader-actions');

    if (files.length) {
      actions.show();
    } else {
      actions.hide();
    }
  },
  getThumbnailSize(onlyNumber) {
    var me = this;
    var item = me.el.find('.dz-message, .dropzone-item');
    var itemWidth = item.length ? item[0].offsetWidth || 132 : 132;
    var thumbSize = parseInt(itemWidth * window.devicePixelRatio);

    if (onlyNumber === true) {
      return thumbSize;
    }

    return `f${thumbSize}xf${thumbSize}`;
  },
  getLang() {
    var lang = {};
    for (var k in this.lang) lang[k] = this.lang[k][locale];
    this.lang = lang;
  },
  switchMode() {
    $(() => {
      //initComponents();

      $('.uploader-switch')
        .off('change.uploader')
        .on('change.uploader', e => {
          var cont = $(e.target).closest('.uploader');
          if (cont.length === 0) return;

          cont.find('.uploader-grid').toggleClass('active', !e.target.checked);
          cont.find('.uploader-list').toggleClass('active', e.target.checked);
        });
    });
  },
  editMode() {
    const params = this.params;

    $(() => {
      //initComponents();

      var toggleDropzoneEditMode = function(e) {
        var el = $(e.target),
          uploader = el.closest('.uploader').find('.upload-zone'),
          checked = el.prop('checked');

        var strings = {
          modeClass    : 'uploader--edit-mode',
          selectedClass: 'dropzone-item--selected'
        };

        var enableEdits = function(uploader) {
          uploader.on('click.edit', '.dropzone-item', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var item = $(this),
              callback = params.checkCallback;

            item.toggleClass(strings.selectedClass);
            var getSelected = function() {
              var selected = [];

              uploader.find(`.${strings.selectedClass}`).each(function() {
                selected.push({
                  id  : this.getAttribute('data-pk'),
                  name: this.querySelector('[data-dz-name]').innerText
                });
              });

              return selected;
            };

            var files = getSelected();

            if (typeof window[callback] === 'function') {
              window[callback](files);
            }
          });
        };
        var disableEdits = function(uploader) {
          uploader
            .off('click.edit', '.dropzone-item')
            .find('.dropzone-item')
            .removeClass(strings.selectedClass);
        };

        if (checked) {
          uploader.addClass(strings.modeClass);
          enableEdits(uploader);
        } else {
          uploader.removeClass(strings.modeClass);
          disableEdits(uploader);
        }
      };
      
      $('.uploader-editable-mode').off('change.editable').on('change.editable', toggleDropzoneEditMode);
    });
  },
  sortable() {
    var me = this;
    $(this.zone.element)
      .sortable({
        containment: 'parent',
        revert     : 200,
        items      : '.dropzone-item:not(.dz-processing)',
        tolerance  : 'pointer',
        cancel     : '.dz-message',
        start      : e => e.target.classList.add('dropzone--sorting'),
        stop       : e => e.target.classList.remove('dropzone--sorting'),
        update(event, ui) {
          ui.item.parent().children('.dropzone-item:not(.dz-processing)').each(function() {
              var el = $(this),
                  index = $(this).index(),
                  data = Object.assign({}, me.globals.sortableJson, {
                    pk_val   : el.data('pk'),
                    SortOrder: index
                  });
                
                
              xcrud.json.save(null, data, null, {disablenotify:true});

            });
        }
      })
      .disableSelection();
  },
  checkMax() {
    var me = this;

    // console.log(`maxFiles: ${me.config.maxFiles}, files: ${me.zone.getAcceptedFiles().length}, ${me.zone.files.length}`);

    if (me.config.maxFiles == me.zone.getAcceptedFiles().length) {
      me.el.find('.dz-message').hide();
    } else {
      me.el.find('.dz-message').show();
    }
  },
  /**
   * Patikrina, ar failas gali turėti peržiūros nuotrauką (nuotrauka, dokumentas, video...)
   * Jeigu gali - grąžina peržiūros URL, jeigu ne - empty string
   * @param {object} file
   * @param {number} itemWidth
   * @param {boolean} cropped
   * @return {string}
   */
  getPreviewUrl(file, itemWidth = 132, cropped = false) {
    let { path } = file;
    if (file.xhr !== undefined) {
      path = JSON.parse(file.xhr.response).path || file.path;
    }

    return xhelper.url.getPreviewUrl(path, itemWidth, cropped);
  },
  app_addFiles(response, zone) {
    if (response.data.type != 'dropzone.files') return;

    let data = response.data,
      files = data.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      file.upload = {
        bytesSent: 0,
        progress : 0,
        total    : file.size,
        filename : file.name
      };

      zone.emit('addedfile', file);
      file.previewElement = $(zone.element).find('.dropzone-item:last')[0];
      file.previewElement.setAttribute('data-upload-id', file.id);
      file.previewElement.scrollIntoView();

      zone.files.push(file);
      zone.emit('processing', file);
      // zone.emit("sending", file);
      zone.emit('uploadprogress', file, 0, file.size);
    }
  },
  app_updateProgress(response, zone) {
    if (response.data.type != 'dropzone.files.progress') return;

    const data = response.data;
    const id = data.id;

    const file = zone.files.filter(file => file.id == id)[0];

    zone.emit(
      'uploadprogress',
      file,
      data.progress.loaded / data.progress.total,
      data.progress.loaded
    );
  },
  app_completeFile(response, zone) {
    if (response.data.type != 'dropzone.files.complete') return;

    let me = $(zone.element).closest('.upload-zone')[0].xDropZone,
      data = response.data,
      id = data.id,
      file = zone.files.filter(file => file.id == id)[0];

    file.pk = data.pk;
    file.path = data.path;
    file.mimetype = data.mimetype;

    file.previewElement.classList.remove('dz-processing');

    zone.emit('success', file);
    zone.emit('complete', file);

    me.files = zone.files;
    me.el.trigger('xdropzone.complete', me);
  },
  lang: {
    uploaded: {
      lt: 'Įkelė',
      en: 'Uploaded by'
    },
    size: {
      lt: 'Dydis',
      en: 'Size'
    },
    name: {
      lt: 'Pavadinimas',
      en: 'Name'
    },
    date: {
      lt: 'Data',
      en: 'Date'
    },
    uploadImage: {
      lt: 'Įkelti nuotrauką',
      en: 'Upload image'
    },
    dictCancelUploadConfirmation: {
      lt: 'Ar tikrai norite atšaukti failo kėlimą?',
      en: 'Are you sure you want to cancel the upload?'
    },
    dictRemoveFileConfirmation: {
      lt: {
        title   : 'Failo trinimas',
        question: 'Ar tikrai norite ištrinti pasirinktą failą?'
      },
      en: {
        title   : 'File deletion',
        question: 'Are you sure you want to delete the selected file?'
      }
    },
    dictFallbackMessage: {
      lt: 'Jūsų naršyklė nepalaiko failų įkelimo tempimo būdu',
      en: 'Your browser doesn\'t support drag\'n\'drop file uploads'
    },
    dictFallbackText: {
      lt: 'Įkelkite failus apačioje esančioje formoje',
      en: 'Upload files using the form below'
    },
    dictFileTooBig: {
      lt:
        'Failas per didelis: ({{filesize}}MiB). Maksimalus dydis: {{maxFilesize}}MiB.',
      en:
        'File size is too big: ({{filesize}}MiB). Max size: {{maxFilesize}}MiB.'
    },
    dictInvalidFileType: {
      lt: 'Toks failo formatas nėra palaikomas',
      en: 'Such file format is not supported'
    },
    dictMaxFilesExceeded: {
      lt: 'Daugiau failų įkelti negalima',
      en: 'Max files exceeded'
    },
    dictResponseError: {
      lt: 'Serveris nėra sukonfiguruotas. Kodas: {{statusCode}}',
      en: 'Server is not configured. Code: {{statusCode}}'
    },
    dictUploadFilesHere: {
      lt: 'Įkelti failą',
      en: 'Upload file'
    },
    dictDelete: {
      lt: 'Trinti',
      en: 'Delete'
    },
    dictYes: {
      lt: 'Taip',
      en: 'Yes'
    },
    dictCancel: {
      lt: 'Atšaukti',
      en: 'Cancel'
    },
    dictDownload: {
      lt: 'Atsisiųsti',
      en: 'Download'
    },
    dictComment: {
      lt: 'Komentuoti',
      en: 'Comment'
    }
  },
  magnificConfig: {
    gallery: {
      enabled: true
    },
    delegate: '[data-mfp-src]',
    type    : 'image'
  }
};

var isMobile = {
  Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any() {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  }
};

Dropzone.autoDiscover = false;
Dropzone.confirm = function(question, accepted, rejected) {
    // $.confirm({
    //     title             : question.title,
    //     content           : question.question,
    //     animateFromElement: true,
    //     type              : 'red',
    //     typeAnimated      : true,
    //     icon              : 'fa fa-warning',
    //     buttons           : {
    //       ok: {
    //         text    : xdropzone.prototype.lang.dictYes[locale],
    //         keys    : ['enter', 'y'],
    //         btnClass: 'btn-danger',
    //         action() {
    //           if (typeof accepted === 'function') accepted();
    //         }
    //       },
    //       cancel: {
    //         text    : xdropzone.prototype.lang.dictCancel[locale],
    //         keys    : ['esc', 'c'],
    //         btnClass: 'pull-left',
    //         action() {
    //           if (typeof rejected === 'function') rejected();
    //         }
    //       }
    //     }
    // });

    var config = {
        type: 'question',
        title: question.title,
        text: question.question,
        showCancelButton: true,        
    };
    
    xdialog.question.show(config, function(isConfirm) {
        if(isConfirm) {
            if (typeof e !== 'undefined') {
              e.preventDefault(); // Ar čia tikrai reikia? Uždėjau if just in case, nes lūžta dėl `undefined` - Darius
            }
            accepted();
        } 
    });
};

(function($) {
  $.fn.xDropZone = function(options) {
    var el = this;

    if (el[0].xDropZone === undefined) {
      el[0].xDropZone = new xdropzone().init(this, options);
      
      return el[0].xDropZone;
    }

    return el[0].xDropZone;
  };  
})(jQuery);

//HALTURKIU HALTURKE bet kitaip neeina iskvesti edita

// setTimeout(() => {
//   $(document).off('click', '[data-dz-edit]').on('click', '[data-dz-edit]', function(e){
//       e.preventDefault();
//       e.stopPropagation();
//       xlog('asd')
//   });
// }, 1000);
